import { render, staticRenderFns } from "./handoverList.vue?vue&type=template&id=b0f452d8&scoped=true"
import script from "./handoverList.vue?vue&type=script&lang=js"
export * from "./handoverList.vue?vue&type=script&lang=js"
import style0 from "./handoverList.vue?vue&type=style&index=0&id=b0f452d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f452d8",
  null
  
)

export default component.exports